import {useFetch, useRequestHeaders} from "nuxt/app";
import {useLocaleStore} from "~/stores/LocaleStore";
import {useNavigationStore} from "~/stores/NavigationStore.js";

export function useServerFetch(url, opts = []) {
    //if app received error code like 503, no need to make any queries
    const nuxtApp = useNuxtApp();
    if (typeof nuxtApp.payload?.error !== 'undefined'){
        if ([403,503].includes(nuxtApp.payload?.error?.statusCode)) {
            return;
        }
    }

    const config = useRuntimeConfig();
    const locale = nuxtApp.$i18n?.locale.value;

    let headers = {
        'Authorization': 'Bearer ' + config.secret,
        'Accept-Language': locale,
        'Environment': 'nuxt',
        'Lang': locale,
        'X-Currency': useLocaleStore().currency?.unit_text,
    };

    if (process.server) {
        headers = {
            ...headers,
            ...useRequestHeaders(['referer', 'cookie'])
        }
    }

    // Csrf header
    const token = useCookie('XSRF-TOKEN', {
        //todo: doesn't work in nuxt checkout
        // no decoding, because it returns error when it cannot decode (Nuxt bug)
        // decode(value) {
        //     return value;
        // }
    });
    if (token.value) {
        headers['X-XSRF-TOKEN'] = token;
    }
    const navigationStore = useNavigationStore();

    const { errors = true, loading = false, pricesLoading = false, headers: customHeaders, ...restOpts } = opts;

    if (errors) {
        navigationStore.setLoading(loading, pricesLoading);
        navigationStore.cleanErrors();
    }

    // Add first slash if missing
    if (url.substring(0, 1) !== '/') {
        url = '/' + url;
    }

    const fetchOptions = {
        headers: {
            ...headers,
            ...customHeaders,
        },
        watch: false,
        credentials: 'include',
        ...restOpts
    };

    return useFetch('/api/server' + url, fetchOptions).finally(() => navigationStore.setLoading(false));
}
